<div class="card-body">
  <p class="card-text">{{ class.shortDescription }}</p>
</div>
